import ApiCoreDocumentProvider from "./ApiCoreDocumentProvider";
import Document from "../../model/document/Document";
import IContextDocument from "../../model/document/IContextDocument";
import { UUID } from "crypto";

class ApiChecklistCoreDocumentProvider extends ApiCoreDocumentProvider {

    async getDocuments(): Promise<Document[]> {
        try {
            const doc = await this.apiProvider.getChecklistCoreDocument(this.context); 
            if (!doc) {
                throw new Error("Checklist core document not found");
            }
            return [doc];
        } catch (error) {
            console.error('Failed to load checklist document:', error);
            return Promise.resolve([]);
        }
    }

    async getDocument(documentUuid: UUID): Promise<IContextDocument | null> {
        const checklistDocs = await this.getDocuments();
        return checklistDocs.length > 0 ? this.toContextDocument(checklistDocs[0]) : null;
    }

    async createInitialDocument(): Promise<IContextDocument> {
        throw new Error("Client should not create initial document. API creates it during GET if needed");
    }
}

export default ApiChecklistCoreDocumentProvider;